import {Switch, Tooltip} from "antd";
import {useState} from "react";
import {blockCustomer} from "../../api/blockCustomer";
import useUserContext from "../../hooks/useUserContext";
import useToast from "../../hooks/useToast";
import {ToastSkin} from "../../context/ToastContext";

interface BlockCustomerSwitchProps {
    initialState: boolean;
    clientId: number;
}

const BlockCustomerSwitch = ({ initialState, clientId }: BlockCustomerSwitchProps) => {
    const [isBlocked, setIsBlocked] = useState(initialState);
    const [isLoading, setIsLoading] = useState(false);
    const { selectedDomain } = useUserContext();
    const { showToast } = useToast();

    const onChange = async (newVal: boolean) => {
        if(selectedDomain) {
            setIsLoading(true);
            const response = await blockCustomer(selectedDomain, clientId, newVal);
            setIsLoading(false);
            if(response.status !== 200 || response.data === false) {
                showToast({ skin: ToastSkin.error, text: 'Failed to update blocked customer'});
            } else {
                setIsBlocked(newVal);
            }
        }
    }

    return (
        <Tooltip title="Block this customer from receiving any messages">
            <Switch loading={isLoading} size="small" value={isBlocked} onChange={onChange} />
        </Tooltip>
    );
}

export default BlockCustomerSwitch;